/**
 * Research tree accessors. Effects are consumed by engines via `has()`
 * checks so save data stays tiny (list of completed node ids).
 */

import { RESEARCH_TREE } from './constants';
import type { GameState } from './types';

export function has(s: GameState, nodeId: string): boolean {
  return s.research.completed.includes(nodeId);
}

export function isUnlocked(s: GameState, nodeId: string): boolean {
  const node = RESEARCH_TREE.find((n) => n.id === nodeId);
  if (!node) return false;
  return node.prereqs.every((p) => has(s, p));
}

/** R&D days after Product Engineer discount. */
export function researchDays(s: GameState, baseDays: number): number {
  const engineer = s.team.hires.find((h) => h.id === 'engineer');
  return engineer?.hired ? Math.round(baseDays * 0.8) : baseDays;
}

export function researchById(id: string) {
  return RESEARCH_TREE.find((n) => n.id === id);
}
